<template>
  <form v-if="!isLoading" @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12">
        <b-checkbox v-model="training.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <app-input
          v-model="training.title"
          label="Título"
          :errors="errors.title"
          required
        ></app-input>
      </div>
      <div class="col-6">
        <app-input
          v-model="training.short_description"
          label="Descrição Curta"
          :errors="errors.short_description"
          required
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-field label="Texto" required>
          <editor
            v-model="training.description"
            :errors="errors.description"
            :api-key="tynemceApiKey"
            :init="tynemceConfig"
          />
        </b-field>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <app-file-picker
          v-model="imageToCrop"
          :errors="errors.image"
          flag="training"
          label="Imagem"
          accept="image/*"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="16 / 9"
          @croppedImage="onCropperImage"
        ></app-image-cropper>

        <img
          v-if="training.image"
          :src="training.image"
          alt="Imagem do Treinamento"
          class="image-preview"
        />
      </div>
      <div class="col-4">
        <app-file-picker
          v-model="training.midia"
          :errors="errors.midia"
          label="Mídia"
          accept=".pdf, video/*"
          required
        ></app-file-picker>
        <a
          v-if="training.midia && id"
          :href="training.midia"
          target="_blank"
          class="midia-link"
          >{{ training.midia }}</a
        >
      </div>
      <div class="col-2">
        <app-input
          v-model="training.points"
          v-money="moneyConfig"
          :errors="errors.points"
          label="Pontos"
          required
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import TrainingService from '@/services/training.service';
import NumberMixin from '@/mixins/NumberMixin';
import Editor from '@tinymce/tinymce-vue';
import { TYNEMCE } from '@/constants/tinymce.constants';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

import { required } from 'vuelidate/src/validators';

export default {
  name: 'trainings-form',
  mixins: [NumberMixin],
  props: ['id', 'errors', 'saving'],
  components: {
    Editor,
    AppImageCropper,
  },
  data: () => {
    return {
      imageToCrop: null,
      isLoading: true,
      training: {
        active: true,
        title: null,
        short_description: null,
        text: null,
        image: null,
        midia: null,
        points: null,
      },
      tynemceApiKey: TYNEMCE.API_KEY,
      tynemceConfig: {
        height: 300,
        menubar: false,
        plugins: TYNEMCE.PLUGINS,
        toolbar: TYNEMCE.TOOLBAR,
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
    };
  },
  validations: {
    training: {
      title: { required },
    },
  },
  methods: {
    loadTraining(id) {
      TrainingService.getId(id)
        .then(({ data: training }) => {
          this.training = {
            ...training,
            points: training.points.toFixed(2),
          };
        })
        .catch(() => this.toastify('Erro ao carregar treinamento.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.training,
        points: this.parseDecimalInput(this.training.points),
      });
    },
    onCropperImage(value) {
      this.training.image = value;
      this.imageToCrop = '';
    },
  },
  beforeMount() {
    if (this.id) this.loadTraining(this.id);
    else this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.image-preview {
  max-height: 400px;
  object-fit: cover;
}
.midia-link {
  font-size: 0.8em;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}
</style>
